import { fetchHandler } from "../fetch";
import type { InternalToolsReportingGroupResponse, Result } from "@/bapi-client/types";
import { BAPI_COMMANDS } from "../types/commands";
export * as templateHandlers from "./templateHandler";

export async function uploadS3File(file: File, upload_url: string) {
  return await fetchHandler(BAPI_COMMANDS.S3_UPLOAD_FILE, "PUT", upload_url, {
    body: file,
    headers: { "Content-Type": file.type },
  });
}

export async function addReportingGroupFleet(
  customerId: string,
  groupId: string,
  fleetIds: string[],
): Promise<Result<InternalToolsReportingGroupResponse>> {
  const response = await fetchHandler(
    BAPI_COMMANDS.INTERNAL_TOOLS_ADD_REPORTING_GROUP_FLEET,
    "POST",
    `/admin/customers/${customerId}/reporting_groups/${groupId}/fleets_bulk`,
    {
      body: {
        fleet_ids: fleetIds,
      },
    },
  );
  if (!response.success) return response;
  const parsed = await response.data.json();
  if (!parsed.success) return parsed;
  return { success: true, data: parsed.data };
}

export async function deleteReportingGroupFleet(
  customerId: string,
  groupId: string,
  fleetId: string,
): Promise<Result<InternalToolsReportingGroupResponse>> {
  const response = await fetchHandler(
    BAPI_COMMANDS.INTERNAL_TOOLS_DELETE_REPORTING_GROUP_FLEET,
    "DELETE",
    `/admin/customers/${customerId}/reporting_groups/${groupId}/fleets/${fleetId}`,
  );
  if (!response.success) return response;
  const parsed = await response.data.json();
  if (!parsed.success) return parsed;
  return { success: true, data: parsed.data };
}
